<template>
  <Popover
    ref="popover"
    :location="location"
  >
    <template #trigger="{ onClick, props }">
      <AppTooltip :disabled="disabled || !tooltipText" class="AIAssistant__tooltip">
        <template #activator="{ props: tooltipProps }">
          <div v-bind="{ ...props, ...tooltipProps }" @click="(e) => handleClick(e, onClick)">
            <slot name="trigger" />
          </div>
        </template>
        <span>{{ tooltipText }}</span>
      </AppTooltip>
    </template>

    <div v-if="icon || $slots.default" class="d-flex column-gap-2 align-center">
      <slot name="icon">
        <app-icon-ds
          :icon="icon"
          color="success"
          size="sm"
          weight="fas"
        />
      </slot>
      <span><slot /></span>
    </div>

    <slot v-else />
  </Popover>
</template>

<script>
import AppTooltip from '@/common/AppTooltip.vue'

import Popover from './Popover.vue'

export default {
  name: 'FeedbackPopover',
  components: { AppTooltip, Popover },
  props: {
    autoCloseDelay: {
      type: Number,
      default: 3000,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tooltipText: {
      type: String,
      default: '',
    },
    location: {
      type: String,
      default: 'top',
    },
    icon: {
      type: String,
      default: null,
    },
  },
  methods: {
    handleClick(event, originalClick) {
      this.$refs.popover?.open()

      if (typeof originalClick === 'function') {
        originalClick(event)
      }

      setTimeout(() => {
        this.$refs.popover?.close()
      }, this.autoCloseDelay)
    },
  },
}
</script>
